
import { Folder } from "@/models/tasks/folder";
import { RepeatedTask } from "@/models/tasks/repeated-task";
import Vue from "vue";
import AppRepeatedTaskEditModal from "./RepeatedTaskEditModal.vue";
import {TaskService} from "@/services";

export default Vue.extend({
	data(){
		return {
			tasks: [] as RepeatedTask[],
			toManageTask: null as null | RepeatedTask
		};
	},
	props: {
		folder: {
			type: Object as ()=>Folder,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		createNew(){
			this.toManageTask = new RepeatedTask();
			this.toManageTask.FolderID = this.folder.ID;
		},
		onTaskUpdate(task:RepeatedTask){
			let i = this.tasks.findIndex(t=>t.ID == task.ID);
			if (i == -1) {
				this.tasks.push(task);
			}else{
				this.$set(this.tasks, i, task);
			}
		},
		async stopTask(task:RepeatedTask){
			let message = this.$ct("are-you-sure-you-want-to-stop-task", {text: task.Text});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) return;
			await TaskService.stopRepeatedTask(task);
			this.tasks = await TaskService.getRepeatedTasksByFolderId(this.folder.ID);
		}
	},
	async mounted(){
		this.tasks = await TaskService.getRepeatedTasksByFolderId(this.folder.ID);
	},
	components: {
		AppRepeatedTaskEditModal
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
